import { component } from 'picoapp'

export default component((node, ctx) => {
  const cartCount = node.querySelector('.js-header-cart-count')
  const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')

  for (let i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', e => {
      e.preventDefault()

      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
    })
  }
  
  ctx.on('cart:updated', state => {
    if (cartCount) {
      cartCount.innerHTML = state.cart.item_count
      
      if (state.cart.item_count > 0) {
        cartCount.classList.remove('hidden');
      }
      else {
        cartCount.classList.add('hidden');
      }
    }
  })
  
  if (cartCount) {
    cartCount.innerHTML = ctx.getState().cart.item_count
  }

  // Main menu hover 
  const $header = $('.js-header');
  const $navbarMenu = $('.js-navbar-menu');
  const $topNavItem = $('.js-menu-hover > a');
  const $navBarNavs = $('.js-navbar-nav');
  
  let headerStatic = false;
  const headerStaticClass = 'header--static';
  const activeClass = 'active';
  const visibleClass = 'visible';
  const hiddenClass = 'hidden';
  let headerHeight = $header.height();
  
  if ($header.hasClass(headerStaticClass)) {
    headerStatic = true;
  }
  else {
    $navBarNavs.each(function() {
      $(this).css({
        'padding-top': headerHeight
      })
    });
  }
  
  if (headerStatic) {
    $topNavItem.click(function(e) {
      
      e.preventDefault();
      
      const $link = $(this).find('> a');
      const target = $link.data('menu-target');
      const $menu = $('[data-menu="' + target + '"]');
      const $otherMenus = $('.js-navbar-nav').not('[data-menu="' + target + '"]');
      const $otherLinks = $navbarMenu.find('> li').not(this).find('> a');
      
      $menu.stop().fadeToggle(150, function() {
        $otherMenus.stop().fadeOut(150);
      });
      
      $topNavItem.not(this).removeClass('active');
      $(this).toggleClass('active');
      
      $otherLinks.removeClass(activeClass);
      $link.toggleClass(activeClass);
      
    });
  }
  else {
    
    $topNavItem.click(function(e) {
      
      e.preventDefault();
      
      const $menu = $(this).closest('.js-menu-hover').find('.js-navbar-nav');
      const $otherMenus = $('.js-menu-hover > a').not(this).closest('.js-menu-hover').find('.js-navbar-nav');
      
      //Show main navigation
      $menu.stop().fadeToggle(150, function() {
        $otherMenus.stop().fadeOut(150);
      });
      
      $topNavItem.not(this).removeClass('active');
      $(this).toggleClass('active');
    });
  }
  
  $('.js-menu-hover').click(function(e) {
    e.stopPropagation();
  });
  
  $('body').click(function() {
    if ($('.js-navbar-nav').length) {
      $('.js-navbar-nav').stop().fadeOut(150);
    }
  });


  // Top bar timer
  if ($('.js-top-bar-timer').length) {
    let $countDownTimer = $('.js-top-bar-timer');
    let year, month, day, hour, minutes, msgAfter, msgPattern;

    year = parseInt($countDownTimer.data('year'));
    month = parseInt($countDownTimer.data('month'));
    day = parseInt($countDownTimer.data('day'));
    hour = parseInt($countDownTimer.data('hour'));
    minutes = parseInt($countDownTimer.data('minutes'));
    msgAfter = $countDownTimer.data('msg-after');
    msgPattern = $countDownTimer.data('msg-pattern');

    let dateEnd = year + '/' + month + '/' + day + ' ' + hour + ':' + minutes;

    console.log(dateEnd);

    let countdown = new Countdown({
      selector: '.js-top-bar-timer',
      msgBefore: '',
      msgAfter: msgAfter,
      msgPattern: msgPattern,
      dateStart: new Date(Date.now()),
      dateEnd: new Date(dateEnd)
    });
  }
  
  // Link product cards
  const $prodCardTrigger = $('.js-prod-card-trigger');
  const $prodCards = $('.js-prod-card');
  
  $prodCardTrigger.hover(function() {
    const target = $(this).data('prod-card-target');
    
    $prodCards.removeClass(activeClass);
    $('[data-prod-card="' + target + '"]').addClass(activeClass);
  },
  function() {
    $prodCards.removeClass(activeClass);
  });
  
  //Collection page header events 
  const $topbar = $('.js-top-bar');
  const $navbar = $('.js-navbar');
  const $collectionNav = $('.js-collection-nav');
  const $collectionNavMobile = $('.js-collection-nav-main');
  const $scrollBanner = $('.js-scroll-banner');
  
  const topbarHeight = $topbar.height();
  const navbarHeight = $navbar.outerHeight();
  
  const navbarFixed = 'navbar--fixed';
  const navbarFixedMobile = 'navbar--fixed-mobile';
  const headerTransparent = 'header--transparent';
  const collectionNavFixed = 'collection__nav--fixed';
  const collectionNavMobileFixed = 'collection__nav__main--fixed';
  
  //Mobile scroll events
  if (matchMedia('screen and (max-width: 767px)').matches) {
    
    const bannerScrollBottom = $scrollBanner.height();
    const navbarTop = $navbar.offset().top;
    const navbarBottom = navbarTop + $navbar.outerHeight();
    let prevSt = 0;
    
    let scrollUpCtr = 0;
    
    $(window).scroll(function() {
      let st = $(window).scrollTop();
      
      if (st >= navbarBottom) {
        $navbar.addClass(navbarFixedMobile);
        
        // Scroll down
        if (st > prevSt) {
          // Hide menu
          $navbar.removeClass('visible');
          $collectionNavMobile.removeClass('offset');
          scrollUpCtr = 0;
        }
        else { //Scroll up
          // Show menu
          scrollUpCtr++;
          
          if (scrollUpCtr >= 30) {
            $navbar.addClass('visible');
            $collectionNavMobile.addClass('offset');
          }
        }
        
        prevSt = st;
      }
      else if (st <= navbarTop) {
        // Place back in orginal placement
        $navbar.removeClass(navbarFixedMobile);
      }
      
      //Pick up collection nav
      
      if ($navbar.hasClass('visible')) {
        st = st + $navbar.outerHeight();
      }
      else {
        st = $(window).scrollTop();
      }
      
      if (st >= bannerScrollBottom) {
        $collectionNavMobile.addClass(collectionNavMobileFixed);
      }
      else {
        $collectionNavMobile.removeClass(collectionNavMobileFixed);
      }
      
    });
  }
  else {
    const bannerScrollBottom = $scrollBanner.height() - navbarHeight;
    
    $(window).scroll(function() {
      
      //Hide top bar on scroll  
      if ($(window).scrollTop() >= topbarHeight) {
        let headerHeight = $navbar.outerHeight();
        $navbar.addClass(navbarFixed);
        
        $navBarNavs.each(function() {
          $(this).css({
            'padding-top': headerHeight
          })
        });
      }
      else {
        $navbar.removeClass(navbarFixed);
      }
      
      //Pick up collection nav
      if ($(window).scrollTop() >= bannerScrollBottom) {
        $collectionNav.addClass(collectionNavFixed);
      }
      else {
        $collectionNav.removeClass(collectionNavFixed);
      }
    });
  }

  // Mobile menu 
  const $toggleMobileMenu = $('.js-mobile-menu-toggle');
  const $mobileMenu = $('.js-navbar-menu');
  const $mobileTab = $('.js-mobile-header-tab');
  
  const $body = document.querySelector('body');
  let scrollPosition = 0;
  
  $toggleMobileMenu.click(function() {
    $('html').toggleClass('no-scroll');
    $('body').toggleClass('no-scroll');
    $(this).toggleClass(activeClass);
    $mobileMenu.toggleClass(activeClass);
    $header.toggleClass('header--mobile-open');
    
    if ($mobileMenu.hasClass(activeClass)) { // If opening menu
      setMobileScrollBarWidth();
      
      let menuTop = $navbar.outerHeight() + $topbar.height();
      
      if ($navbar.hasClass(navbarFixedMobile)) {
        menuTop = menuTop - $topbar.height();
      }
      
      $mobileMenu.css({
        'top': menuTop,
        'height': 'calc(100vh - ' + menuTop + 'px)'
      });
  
    }
  });
  
  $mobileTab.click(function() {
    const $content = $('.js-mobile-header-content[data-menu="' + $(this).attr('data-menu-target') + '"]');
    
    $mobileTab.removeClass(activeClass);
    $(this).addClass(activeClass);
    
    $('.js-mobile-header-content').removeClass(activeClass);
    $content.addClass(activeClass);
  });
  
  function setMobileScrollBarWidth() {
    // Mobile header image slider 
    const $mobileHeaderSlider = $('.js-mobile-header-slider');
    const $mobileHeaderBar = $('.js-mobile-header-scroll-bar > span');
    const mobileHeaderBarWidth = $('.js-mobile-header-scroll-bar').width();
    let scrollWidth = 0;
    
    $('.js-mobile-header-slider > li').each(function() {
      scrollWidth += $(this).outerWidth(true);
    });
    
    let scrollRatio = scrollWidth / mobileHeaderBarWidth;
    let scrollBarWidth = (100 / (scrollWidth / $mobileHeaderSlider.width())) + '%';

    //Set scrollbar width
    $mobileHeaderBar.width(scrollBarWidth);
    
    $mobileHeaderSlider.scroll(function() {
      const scrollLeft = $(this).scrollLeft() / scrollRatio;
      
      $mobileHeaderBar.css({
        'left': scrollLeft
      })
    });
  }
  
  setMobileScrollBarWidth();
  
  //Panels 
  const $panelOverlay = $('.js-overlay');

  $('.js-toggle-panel').click(function() {
    const $panel = $('.js-panel[data-panel="' + $(this).attr('data-panel-target') + '"]');

    if ($panel.length) {
      $panelOverlay.addClass('active');
      $panel.addClass('active');
      $('body').addClass('no-scroll');
      $('html').addClass('no-scroll');
    }
  });
  
  $('.js-close-panel').click(function() {
    $(this).closest('.js-panel').removeClass('active');
    $panelOverlay.removeClass('active');
    $('body').removeClass('no-scroll');
    $('html').removeClass('no-scroll');
  });

  $panelOverlay.click(function() {
    let $panel = $('.js-panel.active');

    if (!$panel.length) {
      return;
    }

    $panel.removeClass('active');
    $(this).removeClass('active');
    $('body').removeClass('no-scroll');
    $('html').removeClass('no-scroll');
  });
  
  
  //Featured quote/block 
  const $featQuotes = $('.js-featured-quotes > span');
  const $featLogos = $('.js-featured-logos > img');
  const quotesLength = $featQuotes.length;
  const $slideArrow = $('.js-feature-slide-toggle');
  
  $featLogos.click(function() {
    const index = $(this).attr('data-index');
    
    $featLogos.removeClass(activeClass);
    $featQuotes.removeClass(activeClass);
    
    $(this).addClass(activeClass);
    $('.js-featured-quotes > span[data-index="' + index + '"]').addClass(activeClass);
    
  });
  
  $slideArrow.click(function() {
    const direction = $(this).attr('data-direction');
    let index = parseInt($('.js-featured-quotes > span.active').attr('data-index'));
    let changeSlide = false;
    
    if (direction == 'next') {
      index++;
      if (index <= quotesLength) {
        changeSlide = true;
      }
    }
    else {
      index--;
      if (index > 0) {
        changeSlide = true;
      }
    }
    
    if (changeSlide) {
      $featLogos.removeClass(activeClass);
      $featQuotes.removeClass(activeClass);
      
      $('.js-featured-quotes > span[data-index="' + index + '"]').addClass(activeClass);
      $('.js-featured-logos > img[data-index="' + index + '"]').addClass(activeClass);
    }
  });




})
